import { type SelectionsMachine } from '../../machine/selection-machine.ts';
import { type SelectionInput } from '../types.ts';

export type StructuralChange = {
  entries: { prev: string[]; next: string[] };
  fields: { prev: string[]; next: string[] };
};

export type StructuralChangeCallback = (
  onChange: (change: StructuralChange) => void
) => VoidFunction;

/**
 * Converts collaborative structural changes into reconciliation events so
 * index-based ranges and focus continue to refer to the same logical rows and
 * columns. The injected subscriber owns the Yjs integration; disposal removes
 * it with the selection machine lifecycle.
 */
export function createYjsChangesInput(
  machine: SelectionsMachine,
  subscribe: StructuralChangeCallback
): SelectionInput {
  let unsubscribe: VoidFunction | null;

  return {
    setup() {
      unsubscribe = subscribe((change) => {
        machine.dispatch({
          type: 'reconcileSelections',
          source: 'api',
          ...change
        });
      });
    },

    dispose() {
      unsubscribe?.();
    }
  };
}
